(function () {
    'use strict';

    angular
        .module('app.logTypes')
        .controller('LogTypesGroupingDetailsController', LogTypesGroupingDetailsController);

    LogTypesGroupingDetailsController.$inject = [
        '$state', '$stateParams', '$window',
        'bootstrap.dialog', 'common', 'dataservice'
    ];

    function LogTypesGroupingDetailsController($state, $stateParams, $window, bsDialog, common, dataservice) {
        /*jshint validthis: true */
        var vm = this;
        var logger = common.logger;
        var $q = common.$q;
        vm.counts = [];
        vm.deletedQuestions = [];
        vm.deletedOptions = [];
        vm.cancel = cancel;
        vm.deleteItem = deleteItem;
        vm.isSaving = false;
        vm.save = save;
        vm.item = undefined;
        vm.isNew = isNew;
        vm.preventDelete = preventDelete;

        vm.questionClick = questionClick;
        vm.addQuestion = addQuestion;
        vm.addOption = addOption;
        vm.showMove = showMove;
        vm.moveOpt = moveOpt;
        vm.deleteOpt = deleteOpt;
        vm.deleteQuestion = deleteQuestion;
        vm.answerTypeText = answerTypeText;
        vm.isRequiredAndNotActivated = isRequiredAndNotActivated;
        vm.sendOnData = [];
 
        activate();

        function activate() {
            var promises = [common.checkIsAdmin(), initLookups(), getItem(), getCounts()];

            vm.sendOnData.push({ "ID": 0, "Description": "Sunday" });
            vm.sendOnData.push({ "ID": 1, "Description": "Monday" });
            vm.sendOnData.push({ "ID": 2, "Description": "Tuesday" });
            vm.sendOnData.push({ "ID": 3, "Description": "Wednesday" });
            vm.sendOnData.push({ "ID": 4, "Description": "Thursday" });
            vm.sendOnData.push({ "ID": 5, "Description": "Friday" });
            vm.sendOnData.push({ "ID": 6, "Description": "Saturday" });
            vm.sendAround = [];
            var h;
            for (var i = 0; i < 24; i++) {
                if (i === 0) {
                    h = "12";
                }
                else {
                    if (i > 12) {
                        h = i % 12;
                    }
                    else {
                        h = i;
                    }
                }

                var desc = (h + ":00");
                desc += Number(i) < 12 ? " AM" : " PM";

                vm.sendAround.push({ "ID": i, "Description": desc })
            }
            
            return common.$q.all(promises).then(function (data) {
                
            }, function (error) { });
        }

        function cancel() {
            backToList();
        }

        function backToList() {
            $state.go("logtypes.list");
        }

        function preventDelete() {
            if (vm.counts.length > 0 || $stateParams.id === "0") {
                return true;
            }
            
            return false;
        }

        function deleteItem() {
            return bsDialog.deleteDialog('Log Type')
                .then(confirmDelete, function () { });

            function confirmDelete() {
                dataservice.deleteItem("api/LogTypes/" + vm.item.ID).then(success).catch(failed);

                function success() {
                    backToList();
                }

                function failed(error) {
                    logger.error(error);
                }
            }
        }

        function isNew() {
            var val = $stateParams.id; 
            return val === "0";
        }

        function getCounts() {
            return dataservice.getItems('api/LogTypes/CountsOfEntries/' + $stateParams.id).then(function (response) {
                vm.counts = response.data;
                return vm.counts;
            }, function (error) { });
        }

        function getItem() {
            var val = $stateParams.id;
            if (val === '0') {
                vm.item = {};
                vm.item.Active = 1;
                vm.item.Questions = [];
                vm.item.SendOnDays = [];
                vm.item.IsReportScheduled = 0;
                vm.item.SendOnNewEntry = 0;
                vm.item.AllowContinueLater = 0;
                common.setAuditInfo(vm.item);
                vm.item.DepartmentID = parseInt($window.localStorage.getItem("SevenPointTaskDepartmentId")) || 0;
                return vm.item;
            }

            return dataservice.getItem("api/LogTypes/" + val)
                .then(function (data) {
                    if (data) {
                        
                        vm.item = data.data;
                        if (!vm.item.Questions) {
                            vm.item.Questions = [];
                        }
                        vm.item.SendOnDays = [];
                        if (vm.item.SendOnSunday) {
                            vm.item.SendOnDays.push(0)
                        }
                        if (vm.item.SendOnMonday) {
                            vm.item.SendOnDays.push(1)
                        }
                        if (vm.item.SendOnTuesday) {
                            vm.item.SendOnDays.push(2)
                        }
                        if (vm.item.SendOnWednesday) {
                            vm.item.SendOnDays.push(3)
                        }
                        if (vm.item.SendOnThursday) {
                            vm.item.SendOnDays.push(4)
                        }
                        if (vm.item.SendOnFriday) {
                            vm.item.SendOnDays.push(5)
                        }
                        if (vm.item.SendOnSaturday) {
                            vm.item.SendOnDays.push(6)
                        }
                        common.setAuditInfo(vm.item);
                       // common.convertDateStringsToDates(vm.item);
                        
                    } else {
                        logger.warning('Could not find item with id = ' + val);
                        $state.go('404');
                    }
                })
                .catch(function (error) {
                    logger.error('Error while getting item with id = ' + val + '; ' + error);
                    $state.go('404');
                });
        }


        function initLookups() {
            dataservice.getItems("api/Departments/ActiveForUser").then(function (data) {
                vm.departments = data.data;
            }, function (error) { });

        }

        function save() {
           
            vm.isSaving = true;

            if (vm.deletedOptions.length > 0) {
                dataservice.saveItem('api/LogTypes/DeleteQuestionItems', vm.deletedOptions).then(function (saveResult) {
                }, function (error) { });
            }

            if (vm.deletedQuestions.length > 0) {
                dataservice.saveItem('api/LogTypes/DeleteQuestions', vm.deletedQuestions).then(function (saveResult) {
                }, function (error) { });
            }
            
            vm.item.SendOnSunday = false;
            vm.item.SendOnMonday = false;
            vm.item.SendOnTuesday = false;
            vm.item.SendOnWednesday = false;
            vm.item.SendOnThursday = false;
            vm.item.SendOnFriday = false;
            vm.item.SendOnSaturday = false;

            if (!vm.item.SendOnNewEntry == 1) {
                vm.item.AllowContinueLater = 0;
            }

            for (var i = 0; i < vm.item.SendOnDays; i++) {
                switch(vm.item.SendOnDays[i]) {
                    case 0:
                        vm.item.SendOnSunday = true;
                        break;
                    case 1:
                        vm.item.SendOnMonday = true;
                        break;
                    case 2:
                        vm.item.SendOnTuesday = true;
                        break;
                    case 3:
                        vm.item.SendOnWednesday = true;
                        break;
                    case 4:
                        vm.item.SendOnThursday = true;
                        break;
                    case 5:
                        vm.item.SendOnFriday = true;
                        break;
                    case 6:
                        vm.item.SendOnSaturday = true;
                        break;
                }
            }

            dataservice.saveItem('api/LogTypes', vm.item).then(function (saveResult) {
                vm.isSaving = false;
                backToList();
            }).catch(function (error) {
                vm.isSaving = false;
            });
            
        }

        function isRequiredAndNotActivated(question) {
            return !question.Activated && question.Required == true;
        }

        function deleteQuestion(question) {
            if (question.HasBeenAnswered) {
                var deleteMsg = "This question has been answered.  Deleting it will also delete all responses to the question.  Are you sure you want to delete this question?";

                return bsDialog.deleteDialog('Log Type', deleteMsg, "Yes", "No").then(function () {
                    vm.deletedQuestions.push(question);
                    vm.item.Questions.splice(vm.item.Questions.indexOf(question), 1);
                }, function () { });

            }
            else {
                if (question.ID > 0) {
                    vm.deletedQuestions.push(question);
                }
                vm.item.Questions.splice(vm.item.Questions.indexOf(question), 1);
            }
           
        }

        function deleteOpt(question, opt) {
            if (opt.ID > 0) {

                if (question.HasBeenAnswered) {
                    var deleteMsg = "This question has been answered.  Deleting this option will also delete all responses to the question that answered with this option.  Are you sure you want to delete this option?";

                    return bsDialog.deleteDialog('Log Type', deleteMsg, "Yes", "No").then(function () {
                        vm.deletedOptions.push(opt);
                        question.Items.splice(question.Items.indexOf(opt), 1);
                    }, function () { });
                }
                else {
                    vm.deletedOptions.push(opt);
                    question.Items.splice(question.Items.indexOf(opt), 1);
                }
            }
            else {
                question.Items.splice(question.Items.indexOf(opt), 1);
            }

        }

        function showMove(dir, question, opt) {
            if (dir == -1) {
                if (question.Items.indexOf(opt) == 0) {
                    return false;
                }
                else {
                    return true;
                }
            }
            else {
                if (question.Items.indexOf(opt) == (question.Items.length - 1)) {
                    return false;
                }
                else {
                    return true;
                }
            }
        }


        function moveOpt(dir, question, opt) {
            var index = question.Items.indexOf(opt);
            var newIndex = index + dir;

            var removedElement;
            if (newIndex > -1 && newIndex < question.Items.length) {
                removedElement = question.Items.splice(index, 1)[0];
            }

            question.Items.splice(newIndex, 0, removedElement);
        }

        function questionClick(question) {
            for (var i = 0; i < vm.item.Questions.length; i++) {
                vm.item.Questions[i].Activated = false;
            }
            question.Activated = true;
        }

        function answerTypeText(question) {
            switch (question.AnswerType) {
                case 1:
                    return "Short Answer";
                case 2:
                    return "Paragraph";
                case 3:
                    return "Multiple Choice";
                case 4:
                    return "Checkboxes";
                case 5:
                    return "Dropdown";
                case 6:
                    return "Date";
                case 7:
                    return "Time";
                case 8:
                    return "Signature";
            }
        }

        function addQuestion() {
            for (var i = 0; i < vm.item.Questions.length; i++) {
                vm.item.Questions[i].Activated = false;
            }
            var question = {};

            question.Question = "";
            question.AnswerType = 1;
            question.AnswerTypeText = "Short Answer";
            question.Items = [];
            question.Active = true;
            question.Activated = true;
            question.Sequence = vm.item.Questions.length;;
            question.Required = false;
            vm.item.Questions.push(question);
        }

        function addOption(question) {
            var i = question.Items.length + 1;
            var opt = { Description: "Option " + i, Active: true };
            question.Items.push(opt)
        }
    }
})();
